import React from 'react';
import { FooterImg, FooterRow, FooterSection, StyledFooter, FooterLinkText, Separator, FooterContainer } from './Footer.styled';
import Link from '@components/Link/Link';
import { UIConstants } from '@constants';

const Footer: React.FC = () => {
    const { addressSection1, lenderText, nmlsConsumerText, equalHousingText, footerLinks, copyRight } = UIConstants.footerComponent;

    return (
        <FooterContainer>
            <StyledFooter id="footerSection">
                <FooterRow>
                    <FooterSection>{addressSection1}</FooterSection>
                    <FooterSection id="footerAddress">
                        <FooterLinkText>
                            {lenderText}&nbsp;
                            <Link
                                onClick={() =>
                                    window.open('https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/2767', '_blank', 'noopener')
                                }
                                eventAttributes={{
                                    type: 'footer_links',
                                    action: `${lenderText} clicked`
                                }}
                            >
                                {nmlsConsumerText}
                            </Link>
                            {equalHousingText}
                            <FooterImg
                                id="footerImg"
                                src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/13605720-a107-4259-864f-4e73b75c8367/renditions/f5c5d10d-38dc-4788-a19e-8a3a6f9fb614?binary=true"
                            />
                        </FooterLinkText>
                    </FooterSection>
                </FooterRow>
                <FooterRow>
                    <FooterSection>
                        <FooterLinkText>
                            {footerLinks.map(({ link, text }) => {
                                return (
                                    <React.Fragment key={text}>
                                        <Link
                                            onClick={() => window.open(link, '_blank')}
                                            eventAttributes={{
                                                type: 'footer_links',
                                                action: `${text} clicked`
                                            }}
                                        >
                                            {text}
                                        </Link>
                                        <Separator>| </Separator>
                                    </React.Fragment>
                                );
                            })}
                        </FooterLinkText>
                    </FooterSection>
                    <FooterSection id="footerCopyright" className="pt-3">
                        {copyRight}
                    </FooterSection>
                </FooterRow>
            </StyledFooter>
        </FooterContainer>
    );
};

export default Footer;
